import { render, staticRenderFns } from "./creatOrder.vue?vue&type=template&id=71494498&scoped=true&"
import script from "./creatOrder.vue?vue&type=script&lang=js&"
export * from "./creatOrder.vue?vue&type=script&lang=js&"
import style0 from "./creatOrder.vue?vue&type=style&index=0&id=71494498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71494498",
  null
  
)

export default component.exports